import React, { useEffect, useState } from 'react';
import useSalesOrdersByCustomerId from '../../hooks/useSalesOrdersByCustomerId';
import { useCreateSalesOrder } from '../../hooks/useSalesOrder';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import Loader from '../common/GlobalLoader';
import { base_url } from '../../baseUrl';
import useCart from '../../hooks/useCart';
import usePermissions from '../../hooks/usePermissions';


function formatMoney(value) {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
  }).format(value);
}

const FavouriteItems = () => {
  const storedUser = localStorage.getItem('user');
  const customerId = storedUser ? JSON.parse(storedUser).CustomerID : null;
  const customerName = storedUser ? JSON.parse(storedUser).CustomerName : null;

  const { salesOrders, loading, error } = useSalesOrdersByCustomerId(customerId);

  const [lineItems, setLineItems] = useState([]);
  const [loadingLineItems, setLoadingLineItems] = useState(false);
  const [lineItemError, setLineItemError] = useState(null);
  const [showLoader, setShowLoader] = useState(true);
  const [quantities, setQuantities] = useState({});
  const { cart, addToCart } = useCart();
  const [showCartPopup, setShowCartPopup] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 15;

  const { canViewPrices, canCreateSalesOrders } = usePermissions();

  const { createSalesOrder, loading: creatingOrder, error: createOrderError } =
    useCreateSalesOrder();

  const handleQuantityChange = (itemId, change) => {
  setQuantities(prev => {
    const current = Number(prev[itemId]) || 0;
    const newValue = Math.max(0, current + change);
    return { ...prev, [itemId]: newValue };
  });
};



  const handleAddToCart = async (itemId) => {
  const qty = quantities[itemId] || 0;

  if (qty <= 0) {
    toast.error('Please select quantity greater than 0');
    return;
  }

  try {
    await addToCart(itemId, qty);
    toast.success('Item added to cart');

    // ✅ Clear quantity after adding to cart
    setQuantities(prev => ({ 
      ...prev, 
      [itemId]: 0 
    }));

  } catch {
    toast.error('Failed to add item to cart');
  }
};


const handleQuantityInput = (itemId, value) => {
  if (value === "") {
    // User cleared the input
    setQuantities(prev => ({
      ...prev,
      [itemId]: ""
    }));
    return;
  }

  let qty = Number(value);

  if (isNaN(qty) || qty < 0) qty = 0;

  setQuantities(prev => ({
    ...prev,
    [itemId]: qty,
  }));
};


  const handleRemoveFromCart = async (itemId) => {
  try {
    await addToCart(itemId, 0); // quantity 0 = remove item
    toast.success('Item removed from cart');
  } catch {
    toast.error('Failed to remove item');
  }
};


  const handleConfirmCartOrder = async () => {
    if (cart.length === 0) {
      toast.error('Cart is empty');
      return;
    }

    const itemsArray = cart.map((ci) => ci.item);
    const qtyArray = cart.map((ci) => Number(ci.qty || 1));

    const result = await createSalesOrder(itemsArray, qtyArray);

    if (result) {
      toast.success('Sales order created successfully');
      setQuantities((prev) => {
        const next = { ...prev };
        cart.forEach((ci) => {
          next[ci.item.item_id] = 0;
        });
        return next;
      });
      // setCart([]);
      setShowCartPopup(false);
    } else {
      toast.error(createOrderError || 'Failed to create sales order');
    }
  };

//   useEffect(() => {
//     const fetchAllOrderDetails = async () => {
//       if (!salesOrders || salesOrders.length === 0) {
//         setShowLoader(false);
//         return;
//       }

//       setLoadingLineItems(true);
//       setLineItemError(null);

//       try {
//         const allLineItems = [];
//       // Calculate 12-week cutoff date
// const twelveWeeksAgo = new Date();
// twelveWeeksAgo.setDate(twelveWeeksAgo.getDate() - 7 * 12);

// // Sort orders by date descending (most recent first)
// const sortedOrders = [...salesOrders].sort(
//   (a, b) => new Date(b.date || b.created_time) - new Date(a.date || a.created_time)
// );

// // Filter to include only orders within the last 12 weeks
// const recentOrders = sortedOrders.filter((order) => {
//   const orderDate = new Date(order.date || order.created_time);
//   return orderDate >= twelveWeeksAgo;
// });

// // If there are still more than 12 weeks worth of data (e.g., overlapping weekly orders),
// // limit to only the most recent 12 weeks.
// const limitedOrders = recentOrders.slice(0, 12);

// for (const order of limitedOrders) {
//   const orderId = order.salesorder_id;
//   try {
//     const response = await axios.get(`${base_url}api/zoho/salesorder/${orderId}`);
//     const orderDetails = response.data;

//     if (orderDetails?.salesorder?.line_items) {
//       const enrichedItems = orderDetails.salesorder.line_items.map((item) => ({
//         ...item,
//         orderNumber: orderDetails.salesorder_number,
//         orderDate: order.date || order.created_time,
//       }));
//       allLineItems.push(...enrichedItems);
//     }
//   } catch (err) {
//     console.warn(`Failed to fetch order ${orderId}:`, err);
//     continue;
//   }
// }


//         setLineItems(allLineItems);
//         setQuantities((prev) => {
//           const next = { ...prev };
//           allLineItems.forEach((it) => {
//             if (next[it.item_id] === undefined) next[it.item_id] = 0;
//           });
//           return next;
//         });
//       } catch (err) {
//         setLineItemError('Failed to fetch line items.');
//       } finally {
//         setLoadingLineItems(false);
//       }
//     };

//     if (!loading) {
//       fetchAllOrderDetails().then(() => {
//         setTimeout(() => setShowLoader(false), 2000);
//       });
//     }
//   }, [salesOrders, loading]);
useEffect(() => {
  const processSalesOrders = () => {
    if (!salesOrders || salesOrders.length === 0) {
      setShowLoader(false);
      return;
    }

    setLoadingLineItems(true);
    setLineItemError(null);

    try {
      // Transform sales orders data to line items format
      const allLineItems = salesOrders.map((order) => ({
        item_id: order['Product ID'],
        name: order['Item Name'],
        item_name: order['Item Name'],
        unit: order['Usage unit'],
        quantity: order['QuantityOrdered'],
        rate: order['Item Price'],
        item_total: order['Item Total'],
      }));

      setLineItems(allLineItems);

      // initialize quantities
      setQuantities((prev) => {
        const next = { ...prev };
        allLineItems.forEach((it) => {
          if (next[it.item_id] === undefined) next[it.item_id] = 0;
        });
        return next;
      });

    } catch (err) {
      setLineItemError("Failed to process line items.");
    } finally {
      setLoadingLineItems(false);
    }
  };

  if (!loading) {
    processSalesOrders();
    setTimeout(() => setShowLoader(false), 2000);
  }
}, [salesOrders, loading]);


  if (loading || loadingLineItems || showLoader) return <Loader />;
  if (error || lineItemError) return <p>Error: {error || lineItemError}</p>;

  // const cartTotal = cart.reduce((acc, ci) => {
  //   const rate = Number(ci.item.rate || 0);
  //   return acc + rate * Number(ci.qty || 0);
  // }, 0);
// Pagination logic
const uniqueItems = Array.from(
  new Map(lineItems.map((item) => [item.item_id, item])).values()
);

const totalPages = Math.ceil(uniqueItems.length / itemsPerPage);

const paginatedItems = uniqueItems.slice(
  (currentPage - 1) * itemsPerPage,
  currentPage * itemsPerPage
);

  return (
    <div className="bg-white border rounded-xl p-4 sm:p-6">
      <Toaster position="top-right" />

      {/* Header */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-4 gap-3">
        <h2 className="text-lg sm:text-xl font-semibold theme-text-primary">
          Most Recent Order Items
        </h2>
        {/* <button
          onClick={() => setShowCartPopup(true)}
          className="px-4 py-2 bg-[#490c15] text-white rounded hover:bg-[#33080F] text-sm sm:text-base"
        >
          View Cart{cart.length > 0 ? ` (${cart.length})` : ''}
        </button> */}
      </div>

      {/* Wide grid: single horizontal scroll for header + rows */}
      <div className="overflow-x-auto -mx-4 sm:mx-0 rounded-lg border border-gray-100">
        <div className="min-w-[820px] divide-y divide-gray-100">
      <div className={`grid gap-2 px-4 py-3 text-sm font-medium text-gray-700 bg-gray-50 ${canViewPrices ? 'grid-cols-[160px_140px_140px_140px_140px_160px_160px]' : 'grid-cols-[160px_140px_140px_160px_160px]'}`}>
  <div>Item Name</div>
  <div className="text-center">Unit</div>
  <div className="text-center">Qty</div>
  {canViewPrices && (
    <>
      <div className="text-center">Rate</div>
      <div className="text-right">Total</div>
    </>
  )}
  <div className="text-center">Order Qty</div>
  <div className="text-center">Action</div>
</div>

        {lineItems.length > 0 ? (
          paginatedItems.map((item, idx) => (

              <div
                key={`${item.item_id}_${idx}`}
                className={`grid gap-2 items-center px-4 py-3 text-sm ${canViewPrices ? 'grid-cols-[160px_140px_140px_140px_140px_160px_160px]' : 'grid-cols-[160px_140px_140px_160px_160px]'}`}
              >
                <div className="text-gray-900">{item.name || item.item_name}</div>
                <div className="text-center text-gray-700">{item.unit}</div>
                <div className="text-center text-gray-700">{item.quantity}</div>
                {canViewPrices && (
                  <>
                    <div className="text-center text-gray-700">{formatMoney(item.rate)}</div>
                    <div className="text-right text-gray-900 font-medium">
                      {formatMoney(item.item_total)}
                    </div>
                  </>
                )}

               <div className="flex items-center justify-center space-x-2">
  <button
    className="px-2 py-1 border rounded"
    onClick={() => handleQuantityChange(item.item_id, -1)}
  >
    -
  </button>

  <input
    type="number"
value={quantities[item.item_id] === undefined ? "" : quantities[item.item_id]}
    onChange={(e) => handleQuantityInput(item.item_id, e.target.value)}
    className="w-12 py-1 text-center border rounded"
    min="0"
  />

  <button
    className="px-2 py-1 border rounded"
    onClick={() => handleQuantityChange(item.item_id, 1)}
  >
    +
  </button>
</div>



                <div className="text-center">
                  {canCreateSalesOrders ? (
                    <button
                      className="px-2 sm:px-3 py-1.5 text-xs sm:text-sm bg-[#490c15] text-white rounded hover:bg-[#33080F] whitespace-nowrap"
                      onClick={() => handleAddToCart(item.item_id)}
                    >
                      Add to Cart
                    </button>
                  ) : (
                    <div className="text-xs text-gray-500 px-2">
                      Contact support
                    </div>
                  )}
                </div>
              </div>
            )
          )
        ) : (
          <div className="px-4 py-4 text-gray-500 text-sm">
            No line items found for this customer.
          </div>
        )}
        </div>
      </div>
      {/* Pagination */}
{totalPages > 1 && (
  <div className="flex flex-wrap justify-center items-center gap-2 mt-4 px-1">
    <button
      className="px-3 py-2 border rounded disabled:opacity-50 text-sm min-h-[44px]"
      disabled={currentPage === 1}
      onClick={() => setCurrentPage(prev => prev - 1)}
    >
      Prev
    </button>

    <span className="px-3">
      Page {currentPage} of {totalPages}
    </span>

    <button
      className="px-3 py-2 border rounded disabled:opacity-50 text-sm min-h-[44px]"
      disabled={currentPage === totalPages}
      onClick={() => setCurrentPage(prev => prev + 1)}
    >
      Next
    </button>
  </div>
)}


      {/* Cart Popup Modal */}
      {showCartPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <div className="bg-white rounded-lg w-full max-w-lg p-4 sm:p-6 shadow-lg">
            <div className="flex items-start justify-between mb-4">
              <div>
                <h2 className="text-lg sm:text-xl font-semibold mb-1">
                  Confirm Sales Order
                </h2>
                <div className="text-sm text-gray-700">
                  <div>
                    <strong>Customer Name:</strong> {customerName}
                  </div>
                  <div>
                    <strong>Date:</strong> {new Date().toLocaleDateString()}
                  </div>
                </div>
              </div>
              <button
                onClick={() => setShowCartPopup(false)}
                aria-label="Close cart"
                className="text-gray-500 hover:text-gray-700 text-xl font-bold"
              >
                ×
              </button>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full text-sm border-collapse mb-4 min-w-[480px]">
                <thead>
                  <tr className="border-b border-gray-300">
                    <th className="text-left py-2">Item Name</th>
                    <th className="text-center py-2">Qty</th>
                    {canViewPrices && (
                      <>
                        <th className="text-right py-2">Price</th>
                        <th className="text-right py-2">Amount</th>
                      </>
                    )}
                    <th className="text-center py-2"> </th>
                  </tr>
                </thead>
                <tbody>
                  {cart.length === 0 ? (
                    <tr>
                      <td colSpan={canViewPrices ? 5 : 3} className="py-4 text-center text-gray-500">
                        No items in cart.
                      </td>
                    </tr>
                  ) : (
                    cart.map((ci) => (
                      <tr key={ci.item.item_id} className="border-b border-gray-200">
                        <td className="py-2">{ci.item.name || ci.item.item_name}</td>
                        <td className="text-center py-2">{ci.qty}</td>
                        {canViewPrices && (
                          <>
                            <td className="text-right py-2">
                              {formatMoney(Number(ci.item.rate || 0))}
                            </td>
                            <td className="text-right py-2">
                              {formatMoney(Number(ci.item.rate || 0) * Number(ci.qty || 0))}
                            </td>
                          </>
                        )}
                        <td className="text-center py-2">
                          <button
                            onClick={() => handleRemoveFromCart(ci.item.item_id)}
                            className="text-red-500 hover:text-red-700"
                          >
                            ×
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* <div className="text-right font-semibold mb-4">
              Total: {formatMoney(cartTotal)}
            </div> */}

            <div className="flex flex-col sm:flex-row justify-end gap-3">
              <button
                onClick={() => setShowCartPopup(false)}
                className="px-4 py-2 border rounded hover:bg-gray-100 w-full sm:w-auto"
              >
                Cancel
              </button>
              {canCreateSalesOrders ? (
                <button
                  onClick={handleConfirmCartOrder}
                  className="bg-[#33080f] text-white px-4 py-2 rounded hover:bg-[#490c15] w-full sm:w-auto"
                  disabled={creatingOrder}
                >
                  {creatingOrder ? 'Creating Order...' : 'Confirm Order'}
                </button>
              ) : (
                <div className="px-4 py-2 text-sm text-gray-600 bg-gray-100 rounded border border-gray-300 w-full sm:w-auto text-center">
                  Contact support to purchase items
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FavouriteItems;
